/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Export_Project_File_TitleInputs */

const en_file_export_project_file_title = /** @type {(inputs: File_Export_Project_File_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project File`)
};

const fr_file_export_project_file_title = /** @type {(inputs: File_Export_Project_File_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fichier de projet`)
};

const de_file_export_project_file_title = /** @type {(inputs: File_Export_Project_File_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projektdatei`)
};

const it_file_export_project_file_title = /** @type {(inputs: File_Export_Project_File_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File di progetto`)
};

const ru_file_export_project_file_title = /** @type {(inputs: File_Export_Project_File_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Файл проекта`)
};

const es_file_export_project_file_title = /** @type {(inputs: File_Export_Project_File_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archivo de proyecto`)
};

const zh_cn2_file_export_project_file_title = /** @type {(inputs: File_Export_Project_File_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`项目文件`)
};

const ja_file_export_project_file_title = /** @type {(inputs: File_Export_Project_File_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクトファイル`)
};

const hi_file_export_project_file_title = /** @type {(inputs: File_Export_Project_File_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोजेक्ट फ़ाइल`)
};

const pt_pt2_file_export_project_file_title = /** @type {(inputs: File_Export_Project_File_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arquivo do projeto`)
};

/**
* | output |
* | --- |
* | "Project File" |
*
* @param {File_Export_Project_File_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_export_project_file_title = /** @type {((inputs?: File_Export_Project_File_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Export_Project_File_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_file_export_project_file_title(inputs)
	if (locale === "de") return de_file_export_project_file_title(inputs)
	if (locale === "it") return it_file_export_project_file_title(inputs)
	if (locale === "ru") return ru_file_export_project_file_title(inputs)
	if (locale === "es") return es_file_export_project_file_title(inputs)
	if (locale === "zh-CN") return zh_cn2_file_export_project_file_title(inputs)
	if (locale === "ja") return ja_file_export_project_file_title(inputs)
	if (locale === "hi") return hi_file_export_project_file_title(inputs)
	if (locale === "pt-PT") return pt_pt2_file_export_project_file_title(inputs)
	return en_file_export_project_file_title(inputs)
});